import { createIcon } from '@chakra-ui/react';

export const DocumentUpload = createIcon({
  displayName: 'DocumentUpload',
  viewBox: '0 0 16 16',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
        <path d="M4.5 8.5V5.5L3.5 6.5" stroke="#6E6789" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.5 5.5L5.5 6.5" stroke="#6E6789" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11 5V7.5C11 10 10 11 7.5 11H4.5C2 11 1 10 1 7.5V4.5C1 2 2 1 4.5 1H7" stroke="#6E6789" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11 5H9C7.5 5 7 4.5 7 3V1L11 5Z" stroke="#6E6789" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </>
  ),
});
